import Button from '@empiriecom/module-components/Button';
import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const StyledProductButton = styled(Button)`
  font-size: 0.688rem;
  width: 100%;
`;

export const ProductButton: FunctionComponent<{ productId: string; seoSlug: string }> = ({
  productId,
  seoSlug,
}): JSX.Element => (
  <StyledProductButton
    asLink
    data-testid="compact-dv-availability"
    layout="default"
    to={`/p/${seoSlug}/${productId}`}
  >
    <FormattedMessage defaultMessage="Zum Artikel" id="compact-detail-view.product-link" />
  </StyledProductButton>
);

export default ProductButton;
